import { render, staticRenderFns } from "./FacebookInfo.vue?vue&type=template&id=17717544&scoped=true&"
import script from "./FacebookInfo.vue?vue&type=script&lang=js&"
export * from "./FacebookInfo.vue?vue&type=script&lang=js&"
import style0 from "./FacebookInfo.vue?vue&type=style&index=0&id=17717544&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17717544",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/www/html/insights/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {VCard,VContainer,VFlex,VLayout,VProgressCircular})
